<table>
  <thead>
    @for (title of headers(); track $index) {
      <th scope="col">{{ title }}</th>
    }
  </thead>

  <tbody>
  <ng-content/>
  </tbody>
</table>
